function readProfile() {
  try {
    const raw = localStorage.getItem('admin.profile') || ''
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function getAdminPermissions() {
  const profile = readProfile()
  return Array.isArray(profile?.permissions) ? profile.permissions : []
}

export function hasAnyPermission(required = []) {
  const list = Array.isArray(required) ? required : [required]
  const owned = getAdminPermissions()
  if (owned.includes('*')) {
    return true
  }
  return list.some((p) => owned.includes(String(p)))
}

/** 超级管理员：权限含 *，或角色编码 SUPER_ADMIN，或角色名「超级管理员」 */
export function isSuperAdmin() {
  try {
    const profile = readProfile()
    const owned = Array.isArray(profile?.permissions) ? profile.permissions : []
    if (owned.includes('*')) return true
    const codes = Array.isArray(profile?.roleCodes) ? profile.roleCodes : []
    if (codes.some((c) => String(c || '').trim().toUpperCase() === 'SUPER_ADMIN')) return true
    const names = Array.isArray(profile?.roleNames) ? profile.roleNames : []
    if (names.some((n) => String(n || '').trim() === '超级管理员')) return true
    return false
  } catch {
    return false
  }
}

